import { Gauge, Check, ChevronDown, Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useApp } from "../context/AppContext";
import { LANGUAGES, CURRENCIES } from "../lib/i18n";

import { tx, useLang, txLocale } from "../lib/i18n";
const trig = "flex items-center gap-1.5 rounded-full border border-[var(--mv-border-2)] px-3 py-1 text-[11px] font-medium text-[var(--mv-text)] hover:border-[var(--mv-teal)] transition-colors";

export const MotionSelect = () => { useLang();
  const { motion, setMotion, t } = useApp();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={trig} data-testid="motion-select-trigger" aria-label={tx("Motion preference")}>
        <Gauge className="h-3.5 w-3.5 text-[var(--mv-teal)]" />
        <span>{t("motion.label")}: <span data-testid="motion-current">{t(`motion.${motion}`)}</span></span>
        <ChevronDown className="h-3 w-3 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[var(--mv-card)] border-[var(--mv-border-2)] text-[var(--mv-text)] min-w-[150px]">
        {["off", "subtle", "full"].map((m) => (
          <DropdownMenuItem key={m} data-testid={`motion-option-${m}`} onClick={() => setMotion(m)} className="flex justify-between cursor-pointer">
            {t(`motion.${m}`)} {tx(motion === m && <Check className="h-3.5 w-3.5 text-[var(--mv-teal)]" />)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const LanguageMenu = ({ align = "start" }) => { useLang();
  const { lang, setLang } = useApp();
  const cur = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={trig} data-testid="language-select-trigger" aria-label={tx("Language")}>
        <Globe className="h-3.5 w-3.5 text-[var(--mv-teal)]" /> {tx(cur.label)} <ChevronDown className="h-3 w-3 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="bg-[var(--mv-card)] border-[var(--mv-border-2)] text-[var(--mv-text)] p-2 w-[260px]">
        <div className="grid grid-cols-2 gap-1" data-testid="language-dropdown-grid">
          {LANGUAGES.map((l) => (
            <DropdownMenuItem key={l.code} data-testid={`language-option-${l.code}`} onClick={() => setLang(l.code)}
              className={`cursor-pointer rounded-lg px-3 py-2 text-sm ${lang === l.code ? "bg-[var(--mv-teal-dim)] text-[var(--mv-teal)]" : ""}`}>
              {tx(l.label)}
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const CurrencyMenu = ({ className = "" }) => { useLang();
  const { currency, setCurrency, rates, t } = useApp();
  const cur = CURRENCIES.find((c) => c.code === currency) || CURRENCIES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={`${trig} ${className}`} data-testid="currency-select-trigger" aria-label={tx("Currency")}>
        <span aria-hidden>{tx(cur.flag)}</span> {cur.code} <ChevronDown className="h-3 w-3 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-[var(--mv-card)] border-[var(--mv-border-2)] text-[var(--mv-text)] w-[230px]">
        {CURRENCIES.map((c) => (
          <DropdownMenuItem key={c.code} data-testid={`currency-option-${c.code}`} onClick={() => setCurrency(c.code)} className="cursor-pointer flex justify-between">
            <span>{tx(c.flag)} {c.code} ({tx(c.symbol)})</span>{tx(currency === c.code && <Check className="h-3.5 w-3.5 text-[var(--mv-teal)]" />)}
          </DropdownMenuItem>
        ))}
        <p className="px-2 pt-2 pb-1 text-[10px] leading-snug text-[var(--mv-dim)]">
          {t("footer.ratesNote")} {tx(rates.updated_at ? `· ${new Date(rates.updated_at).toLocaleDateString(txLocale())}` : "")}
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
